<div class="content-header row my-1">
    <div class="content-header-left col-md-7 col-12 mb-2">
        <div class="row breadcrumbs-top">
            <div class="col-12">
                <h2 class="content-header-title float-left mb-0 border-right">{{heading}}</h2>
            </div>
        </div>
    </div>
</div>